import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { MasterInsurancePolicyDTO } from '../../data/dtos/master-insurance/master-insurance-policy.dto';
import { InsurancePmcDTO } from '../../data/dtos/master-insurance/insurance-pmc.dto';
import { MasterInsurancePolicySettingDTO } from '../../data/dtos/master-insurance/master-insurance-policy-settings.dto';
import { MasterInsuranceProductPriceDTO } from '../../data/dtos/master-insurance/master-insurance-product-price.dto';
import { UpdateMasterInsuranceDTO } from '../../data/dtos/master-insurance/update-master-insurance-policy.dto';
import { MasterInsurancePolicyCertificateDTO } from '@root/manager-base/data/dtos/master-insurance/master-insurance-policy-certificate.dto';
import { PagingResultsDTO } from '@root/manager-base/data/dtos/paging-results.dto';
import { StripePaymentMethodCardDTO } from '@root/manager-base/data/dtos/payments/stripe-payment-method-card.dto';
import { MasterInsuranceInvoiceDTO } from '@root/manager-base/data/dtos/master-insurance/master-insurance-invoice.dto';

const routeRoot = 'masterInsurancePolicies';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;

const actions = {
    getPmcMasterPolicy: {
        method: 'GET',
        url: `${baseRoute}/self`
    },
    createPmcMasterPolicy: {
        method: 'POST',
        url: `${baseRoute}`
    },
    deletePmcMasterPolicy: {
        method: 'DELETE',
        url: `${baseRoute}/:msiPropertyManagerId`
    },
    getPmcSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/masterInsurancePolicySettings`
    },
    getPmcProductsPrice: {
        method: 'GET',
        url: `${BASE_PATH_API}/masterInsuranceProductPrices`
    },
    updatePmcMasterPolicy: {
        method: 'PUT',
        url: `${baseRoute}/:policyId`
    },
    getPolicyCertificates: {
        method: 'GET',
        url: `${baseRoute}/:policyId/certificates`,
        params: {
            '$count': true,
            '$top': 2
        }
    },
    getPolicyCertificatesByLease: {
        method: 'GET',
        url: `${baseRoute}/:policyId/certificates/active`,
    },
    getPaymentMethod: {
        method: 'GET',
        url: `${BASE_PATH_API}/masterInsurancePaymentMethods/default`
    },
    deleteMasterInsuranceCertificate: {
        method: 'DELETE',
        url: `${baseRoute}/:policyId/certificates/:masterInsurancePolicyCertificateId`
    },
    getMasterInsuranceInvoice: {
        method: 'GET',
        url: `${BASE_PATH_API}/masterInsuranceInvoices/self`
    },
    payMasterInsuranceInvoice: {
        method: 'PUT',
        url: `${BASE_PATH_API}/masterInsuranceInvoices/self`
    }
};

export interface IMasterInsuranceApi {
    getPmcMasterPolicy(): Promise<MasterInsurancePolicyDTO>
    createPmcMasterPolicy(): Promise<InsurancePmcDTO>
    deletePmcMasterPolicy(request: any): Promise<MasterInsurancePolicyDTO>
    getPmcSettings(): Promise<MasterInsurancePolicySettingDTO>
    getPmcProductsPrice(): Promise<MasterInsuranceProductPriceDTO>
    updatePmcMasterPolicy(request: any, dto: UpdateMasterInsuranceDTO): Promise<MasterInsurancePolicyDTO>
    getPolicyCertificates(request: any): Promise<PagingResultsDTO<MasterInsurancePolicyCertificateDTO>>
    getPolicyCertificatesByLease(request: any): Promise<MasterInsurancePolicyCertificateDTO>
    getPaymentMethod(): Promise<StripePaymentMethodCardDTO>
    deleteMasterInsuranceCertificate(request: any): Promise<any>
    getMasterInsuranceInvoice(request: any): Promise<MasterInsuranceInvoiceDTO>,
    payMasterInsuranceInvoice(request: any): Promise<MasterInsuranceInvoiceDTO>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function MasterInsuranceApi(): IMasterInsuranceApi {
    return createActions(actions);
}
